// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 8 hooks for backend/sin.

import { useBackend } from '../useBackend'

/** POST /api/sin/accrueSinOfferings */
export function useAccrueSinOfferings<T = any>() {
  return useBackend<T>('sin/accrueSinOfferings')
}

/** POST /api/sin/decideSinOffering */
export function useDecideSinOffering<T = any>() {
  return useBackend<T>('sin/decideSinOffering')
}

/** POST /api/sin/getSinBoard */
export function useGetSinBoard<T = any>() {
  return useBackend<T>('sin/getSinBoard')
}

/** POST /api/sin/markSinOfferingPaid */
export function useMarkSinOfferingPaid<T = any>() {
  return useBackend<T>('sin/markSinOfferingPaid')
}

/** POST /api/sin/raiseSinOffering */
export function useRaiseSinOffering<T = any>() {
  return useBackend<T>('sin/raiseSinOffering')
}

/** POST /api/sin/recordSinRepresentation */
export function useRecordSinRepresentation<T = any>() {
  return useBackend<T>('sin/recordSinRepresentation')
}

/** POST /api/sin/releaseSinOfferings */
export function useReleaseSinOfferings<T = any>() {
  return useBackend<T>('sin/releaseSinOfferings')
}

/** POST /api/sin/saveSinPolicy */
export function useSaveSinPolicy<T = any>() {
  return useBackend<T>('sin/saveSinPolicy')
}
